import {WidgetDetail} from './model/widget-detail';
import {PanelModel} from '@syncfusion/ej2-layouts';
import {Position} from '../dashboard/model/position';

export const updateWidgetOrder = (widget: WidgetDetail, numberOfColumns: number, panel: PanelModel): WidgetDetail => {
  // order = (numberOfColumns * x) + y
  const newOrder = numberOfColumns * panel.row + panel.col;

  return new WidgetDetail(widget.id,
                          widget.widgetName,
                          widget.applicationNames,
                          newOrder,
                          widget.size);
};

export const getPositionOfWidget = (widget: WidgetDetail, numberOfColumns: number): Position => {
  // 0 < y < numberOfColumns
  // x = (order - y) / numberOfColumns
  // (order - y) % numberOfColumns = 0 because x is integer

  for (let y = 0; y < numberOfColumns; y++) {
    if ((widget.order - y) % numberOfColumns === 0) {
      const x = (widget.order - y) / numberOfColumns;
      return new Position(x, y);
    }
  }

  return new Position(0, 0);
};

export const graphColors = [
  '#1b9dde',
  '#ca2828',
  '#FF8E00',
  '#94BB54',
  '#19288D',
  '#00bfbf',
  '#dc5b20',
  '#e8bc34',
  '#afda3d',
  '#1e7ba9',
  '#bdc1c5',
  '#339933',
  '#f0484b',
  '#5f92e2'
];
